import { useDrop, ConnectDropTarget } from 'react-dnd';

const useDropElement: Function = (
  elementType: string,
  hoverIndex: number,
  isDisabled: boolean,
  onDropItem: (item: DropItem, monitor: DragMonitor) => Promise<void>,
  onHoverItem: (dragIndex: number, hoverIndex: number) => void,
): DropOptions => {
  const [{ canDrop, isOver }, drop]: [DropProps, ConnectDropTarget] = useDrop({
    accept: [elementType],
    hover(item: DropItem): void {
      const dragIndex: number = item.index;

      if (onHoverItem) {
        onHoverItem(dragIndex, hoverIndex);
      }
    },
    drop: async (item: DropItem, monitor: DragMonitor): Promise<void> => {
      if (canDrop && onDropItem) {
        await onDropItem(item, monitor);
      }
    },
    collect: (monitor: DropMonitor): DropProps => ({
      isOver: monitor.isOver(),
      canDrop: !isDisabled && monitor.canDrop(),
    }),
  });

  return {
    isCanBeDropped: canDrop,
    isDropping: isOver,
    dropRef: drop,
  };
};

export default useDropElement;
